import { useHistory } from 'react-router-dom';
import {useServices,constants} from "cng-web-lib";
import React, { useEffect, useState } from "react";
import AceHighwayManifestApiUrls from 'src/apiUrls/AceHighwayManifestApiUrls'

/**
 * Method to return the style based on the Status Type
 * @param {*} status 
 */

function StatusStyle (status){
    switch (status) {
        case 0:
        case "0":
        case 1:
        case "1":
          return { background: "lightgrey", color: "white", textAlign: "center" }
          break;
        case 17:
        case "17":
          return { background: "lightgreen", color: "white", textAlign: "center" }
          break;   
        case 200:
        case "200":
          return { background: "lightgreen", color: "white", textAlign: "center" }
          break;
        case 25:
        case "25":
          return { background: "#8B8000", color: "white", textAlign: "center" }
          break; 
        case 20:
        case "20":
          return { background: "indianred", color: "white", textAlign: "center"}
          break;
        case 21:
        case "21":
          return { background: "indianred", color: "white", textAlign: "center"}
          break;
        case 22:
        case "22":
          return { background: "indianred", color: "white", textAlign: "center"}
          break; 
        case 28:
        case "28":
          return { background: "indianred", color: "white", textAlign: "center"}
          break; 
        case 29:
        case "29":
          return { background: "indianred", color: "white", textAlign: "center"}
          break; 
        case 32:
        case "32":    
          return { background: "green", color: "white", textAlign: "center"}
          break;
        case 33:
        case "33":    
          return { background: "green", color: "white", textAlign: "center"}
          break;    
        case 1048:
        case "1048":    
          return { background: "lightgreen", color: "white", textAlign: "center"}
          break;
        case 1049:
        case "1049":
          return { background: "indianred", color: "white", textAlign: "center"}
          break;
        case 1002:
        case "1002":    
          return { background: "mediumaquamarine", color: "white", textAlign: "center"}
          break;
        case 1003:
        case "1003":    
          return { background: "green", color: "white", textAlign: "center"}
          break;
        case 1004:
        case "1004":    
          return { background: "indianred", color: "white", textAlign: "center"}
          break;
        case 1000:
        case "1000":    
          return { background: "green", color: "white", textAlign: "center"}
          break;
        case 1001:
        case "1001":
          return { background: "indianred", color: "white", textAlign: "center"}
          break;
        case 1005:  
        case "1005":
          return { background: "lightblue", color: "white", textAlign: "center"}
          break;
        case 1008: 
        case "1008":
          return { background: "lightgrey", color: "white", textAlign: "center"}
          break;   
        default:
          return { background: "yellow", color: "black", textAlign: "center"}
          break;                
      } 
}

function ACEStatusStyle (rowData, manPort){
  switch (rowData.status) {
      case 1000:
      case "1000":
        if(rowData.eventLocation && manPort && rowData.shipmentType === 'REGULAR' && rowData.eventLocation !== manPort){
          return { background: "indianred", color: "white", textAlign: "center"}
          break;
        }
        return { background: "green", color: "white", textAlign: "center"}
          break;
      case 1001:
      case "1001":
        return { background: "indianred", color: "white", textAlign: "center"}
        break;
      case 1002:
      case "1002":    
        return { background: "mediumaquamarine", color: "white", textAlign: "center"}
        break;
      case 1003:
      case "1003":    
        return { background: "green", color: "white", textAlign: "center"}
        break;
      case 1004:
      case "1004":    
        return { background: "indianred", color: "white", textAlign: "center"}
        break;
      
      case 1005:  
      case "1005":
        return { background: "lightblue", color: "white", textAlign: "center"}
        break;
      case 1007:
        case "1007":
          return { background: "indianred", color: "white", textAlign: "center"}
          break;
      case 1008: 
      case "1008":
        return { background: "lightgrey", color: "white", textAlign: "center"}
        break;   
      default:
        return { background: "yellow", color: "white", textAlign: "center"}
        break;                
    } 
}

/**
 * Method to Submit Multiple messages to Queue
 * @param {*} url 
 * @param {*} rowData 
 * @param {*} showNotification 
 * @param {*} cngTableRef 
 */
function SubmitAll (url, rowData, showNotification, cngTableRef, successMsg, errorMsg,securedSendRequest){
  
  function onSuccess(response) {

    if (response.status == 200) {
      const data= response.data
      var errorMessage = null;
      for (var key in data) {
        var obj = data[key];
        if( obj.errorMessages!=null && obj.errorMessages.length>0){
          errorMessage = obj.errorMessages;
          showNotification("error", errorMessage)
        }
          
      }

      if(errorMessage==null || errorMessage.length == 0)
      {
        showNotification("success", successMsg)

        if (cngTableRef.current.performRefresh) {
          cngTableRef.current.performRefresh()
        }
      }
    } else {
      showNotification("error", errorMsg)
    }
  }

  function onError(error) {
    showNotification("error", errorMsg)
  }

  function onComplete(response){

  }
  const config = {}

  securedSendRequest.execute('POST',url, rowData, onSuccess, onError, onComplete,config,null);
}

function SubmitAndRedirect (url, destUrl,rowData, showNotification, successMsg, setIsLoading, history, errorMsg,securedSendRequest){
  setIsLoading(true)
  
  function onSuccess(response) {
    const data=response.data
    var errorMessage = null;
    var errorFlag = false;
    for (var key in data) {
      var obj = data[key];
      if( obj.errorMessages!=null && obj.errorMessages.length>0){
        errorMessage = obj.errorMessages;
        showNotification("error", errorMessage)
        errorFlag = true;
      }
    }
    if(!errorFlag){
      showNotification("success", successMsg)
      setIsLoading(false)
      history.push(destUrl)
    }
     setIsLoading(false)
  }

  function onError(error) {
  }

  function onComplete(response){

  }
  const config = {}

  securedSendRequest.execute('POST',url, rowData, onSuccess, onError, onComplete,config,null);

}

function SubmitMultiplefromManifest (url, rowData, showNotification, successMsg,setIsLoading,history,errorMsg,securedSendRequest){

  function onSuccess(response) {

    const data=response.data
    if(data.errorMessages!=null && data.errorMessages.length>0)
    {
      showNotification("error", data.errorMessages)
    }
    else if(data.errorMessages===null || data.errorMessages===undefined)
    {
      showNotification("success", successMsg)
      setIsLoading(false)
      history.push("/aci-highway/manifest")
    }
    else{
      showNotification("error", errorMsg)
    }
     setIsLoading(false)
  }

  function onError(error) {
  }

  function onComplete(response){
  }
  const config = {}

  securedSendRequest.execute('POST',url, rowData, onSuccess, onError, onComplete,config,null);
}

function AttachAll (url, rowData, showNotification, successMsg,history,goBackUrl,securedSendRequest){

  function onSuccess(response) {

    const data=response.data
    if(data.errorMessages!=null && data.errorMessages!==undefined &&data.errorMessages.length>0 )
    {
      showNotification("error", data.errorMessages)
    }
    else if(data.errorMessages===null || data.errorMessages===undefined)
    {
      showNotification("success", successMsg)
      history.push(goBackUrl);
    }
  }

  function onError(error) {
    console.log(error);
  }

  function onComplete(response){

  }
  const config = {}

  securedSendRequest.execute('POST',url, rowData, onSuccess, onError, onComplete,config,null);
    
}

/**
 * Method to Submit Multiple messages to Queue
 * @param {*} url 
 * @param {*} rowData 
 * @param {*} showNotification 
 * @param {*} cngTableRef 
 */
function DettachAll (url, rowData, showNotification, successMsg,setIsLoading,securedSendRequest){

  function onSuccess(response) {

   const data=response.data;
   if(data.errorMessages!=null && data.errorMessages.length>0)
   {
     showNotification("error", data.errorMessages)
   }
   else if(data.errorMessages===null || data.errorMessages===undefined)
   {
     showNotification("success", successMsg)
     console.log(rowData.manifestId)
   }
   setIsLoading(false)
  }

  function onError(error) {
    console.log(error);
  }

  function onComplete(response){

  }
  const config = {}

  securedSendRequest.execute('POST',url, rowData, onSuccess, onError, onComplete,config,null);
   
}

/**
 * Method to disable Submit Button based on Status
 * @param {*} rowData 
 */
function DisableSubmitButton(rowData){
    var isDisable = false
    for(let record in rowData){
      var row = rowData[record]
      if(row.hdrStatus === 1048 || row.hdrStatus === 1 || row.a6aStatus === "1048" || row.a6aStatus === "1"){
        isDisable = true
        break
      }
    }
    return isDisable
}


/**
 * Method to disable Aci Highway Submit Button based on Status
 * @param {*} rowData 
 */
 function DisableHighwaySubmitButton(rowData){
  var isDisable = false
  for(let record in rowData){
    var row = rowData[record]
    if(row.status === "1008"){
      isDisable = true
      break
    }
  }
  return isDisable
}

/**
 * Method to disable Dettach Button based on Status
 * @param {*} rowData 
 */
 function DisableDettachButton(rowData){
  var isDisable = false
  for(let record in rowData){
    var row = rowData[record]
    if(row.status === "1000" || row.status === "1008" || row.status==="1007" || row.status==="1004"){
      isDisable = true
      break
    }
  }
  return isDisable
}

/**
 * Method to disable Attach Button based on Status
 * @param {*} rowData 
 */
 function DisableAttachButton(rowData){
  var isDisable = false
  for(let record in rowData){
    var row = rowData[record]
    if(row.status === "1008" || row.status === "1006" || row.status ==="1002"){
      isDisable = true
      break
    }
  }
  return isDisable
}

/**
 * Method to disable Submit Button based on Status
 * @param {*} rowData 
 */
function DisableInvoiceSubmitButton(rowData){
  var isDisable = false
  for(let record in rowData){
    var row = rowData[record]
    if(row.status === 'ST'){
      isDisable = true
      break
    }
  }
  return isDisable
}

/**
 * Method to disable Delete Button based on Status
 * @param {*} rowData 
 */
function DisableDeleteButton(rowData){
  var isDisable = false
  for(let record in rowData){
    var row = rowData[record]
    if(row.hdrStatus !== 1005){
      isDisable = true
      break
    }
  }
  return isDisable
}

function DisableDeleteButtonForHighway(rowData){
  var isDisable = false
  for(let record in rowData){
    var row = rowData[record]
    if(row.status !== "1005"){
      isDisable = true
      break
    }
  }
  return isDisable
}

function getStatusMetadataMini(status) {

  switch (status) {
    case 1000: case '1000':
      return { label: 'Accepted', color: '#29A855', contrastColor: '#ffffff' }
    case 1001: case '1001':
      return { label: 'Rejected', color: '#DF2901', contrastColor: '#ffffff' }  
    case 1003: case '1003':  
      return { label: 'Cancellation Accepted', color: '#FFC400', contrastColor: '#121212' }
    case 1004: case '1004': 
      return { label: 'Cancellation Rejected', color: '#DF2901', contrastColor: '#ffffff' }  
    case 1005: case '1005': case 'DR':
      return { label: 'Draft', color: '#0662BB', contrastColor: '#ffffff' }
    case 1006: case '1006':
      return { label: 'Status Notification', color: '#d3d3d3', contrastColor: '#121212' }    
    case 1007: case '1007':   
      return { label: 'Replace Rejected', color: '#DF2901', contrastColor: '#ffffff' }
    case 1008: case '1008':
      return { label: 'Sent', color: '#ffc400', contrastColor: '#121212' }
    case 1009: case '1009':
      return { label: 'Modification Rejected', color: '#DF2901', contrastColor: '#ffffff' }   
    default:
      return { label: status, color: '#121212', contrastColor: '#ffffff' }  
  } 
}

function getStatusMetadata(status, translatedTextsObject) {

  //added new parameter translatedTextsObject(NaCommonTranslationText.js) to support multiple language

  switch (status) {
    case 0: case '0':
      return { label: translatedTextsObject ? translatedTextsObject.pendingAutoSend : 'Pending Auto Send', color: '#ffc400', contrastColor: '#121212' }
    case 1: case '1':
      return { label: translatedTextsObject ? translatedTextsObject.cbsaReceivedAndProcessing : 'CBSA Received and Processing', color: '#ffc400', contrastColor: '#121212' }
    case 2: case '2':
      return { label: translatedTextsObject ? translatedTextsObject.registered : 'Registered', color: '#ffc400', contrastColor: '#121212' }
    case 3: case '3':
      return { label: translatedTextsObject ? translatedTextsObject.pending : 'Pending', color: '#ffc400', contrastColor: '#121212' }
    case 4: case '4':
      return { label: translatedTextsObject ? translatedTextsObject.sendSuccessfully : 'Send Successfully', color: '#ffc400', contrastColor: '#121212' }
    case 14: case '14':
      return { label: translatedTextsObject ? translatedTextsObject.rejectType : 'Reject Type', color: '#DF2901', contrastColor: '#ffffff' }
    case 17: case '17':
      return { label: translatedTextsObject ? translatedTextsObject.functionalAcnkowledgementMessageReceived : 'Functional Acnkowledgement Message Received', color: '#29A855', contrastColor: '#ffffff' }
    case 20: case '20':
      return { label: translatedTextsObject ? translatedTextsObject.administrationError : 'Administration Error', color: '#DF2901', contrastColor: '#ffffff' }
    case 21: case '21':
      return { label: translatedTextsObject ? translatedTextsObject.enforcementError : 'Enforcement Error', color: '#DF2901', contrastColor: '#ffffff' }
    case 22: case '22':
      return { label: translatedTextsObject ? translatedTextsObject.syntaxError : 'Syntax Error', color: '#DF2901', contrastColor: '#ffffff' }
    case 25: case '25':
      return { label: translatedTextsObject ? translatedTextsObject.riskAssessment : 'Risk Assessment', color: '#DF2901', contrastColor: '#ffffff' }
    case 28: case '28':
      return { label: translatedTextsObject ? translatedTextsObject.batchError : 'Batch Error', color: '#DF2901', contrastColor: '#ffffff' }
    case 29: case '29':
      return { label: translatedTextsObject ? translatedTextsObject.dataError : 'Data Error', color: '#DF2901', contrastColor: '#ffffff' }
    case 32: case '32':
      return { label: translatedTextsObject ? translatedTextsObject.supplementaryMatchYes : 'Supplementary Match Yes', color: '#29A855', contrastColor: '#ffffff' }
    case 33: case '33':
      return { label: translatedTextsObject ? translatedTextsObject.supplementaryMatchNo : 'Supplementary Match No', color: '#DF2901', contrastColor: '#ffffff' }
    case 200: case '200':
      return { label: translatedTextsObject ? translatedTextsObject.conveyanceArrived : 'Conveyance Arrived', color: '#29A855', contrastColor: '#ffffff' }
    case 1000: case '1000':
      return { label: translatedTextsObject ? translatedTextsObject.accepted : 'Accepted', color: '#29A855', contrastColor: '#ffffff' }
    case 'AC':
      return { label: translatedTextsObject ? translatedTextsObject.acceptedMatched : 'Accepted / Matched', color: '#29A855', contrastColor: '#ffffff' }
    case 'MF':  
      return { label: translatedTextsObject ? translatedTextsObject.manifestForward : 'Manifest Forward', color: '#29A855', contrastColor: '#ffffff' }
    case 1001: case '1001': case 'RJ':
      return { label: translatedTextsObject ? translatedTextsObject.rejected : 'Rejected', color: '#DF2901', contrastColor: '#ffffff' }
    case 1002: case '1002': case 'TP':  
      return { label: translatedTextsObject ? translatedTextsObject.template : 'Template', color: '#0662bb', contrastColor: '#ffffff' }
    case 1003: case '1003': case 'CL':  
      return { label: translatedTextsObject ? translatedTextsObject.cancellationAccepted : 'Cancellation Accepted', color: '#FFC400', contrastColor: '#121212' }
    case 1004: case '1004': case 'CR':  
      return { label: translatedTextsObject ? translatedTextsObject.cancellationRejected : 'Cancellation Rejected', color: '#DF2901', contrastColor: '#ffffff' }
    case 1005: case '1005': case 'DR':
      return { label: translatedTextsObject ? translatedTextsObject.draft : 'Draft', color: '#0662BB', contrastColor: '#ffffff' }
    case 1006: case '1006': case 'SN':
      return { label: translatedTextsObject ? translatedTextsObject.sn : 'SN', color: '#d3d3d3', contrastColor: '#121212' }
    case 1024: case '1024': case 'SN-TA':
      return { label: translatedTextsObject ? translatedTextsObject.snTruckArrived : 'SN-Truck Arrived', color: '#d3d3d3', contrastColor: '#121212' }
    case 1025: case '1025': case 'SN-GR':
      return { label: translatedTextsObject ? translatedTextsObject.snGoodsRelease : 'SN-Goods Released', color: '#d3d3d3', contrastColor: '#121212' }
    case 1007: case '1007': case 'MR':  
      return { label: translatedTextsObject ? translatedTextsObject.modificationRejected : 'Modification Rejected', color: '#DF2901', contrastColor: '#ffffff' }
    case 1008: case '1008': case 'ST':
      return { label: translatedTextsObject ? translatedTextsObject.sent : 'Sent', color: '#ffc400', contrastColor: '#121212' }
    case 1009: case '1009': case 'PL':
      return { label: translatedTextsObject ? translatedTextsObject.preliminary : 'Preliminary', color: '#0662BB', contrastColor: '#ffffff' }
    case 1010: case '1010':
      return { label: translatedTextsObject ? translatedTextsObject.cp : 'CP', color: '#0662BB', contrastColor: '#ffffff' }
    case 1011: case '1011':
      return { label: translatedTextsObject ? translatedTextsObject.cancel : 'Cancel', color: '#ffc400', contrastColor: '#121212' }
    case 1012: case '1012':
      return { label: translatedTextsObject ? translatedTextsObject.replace : 'Replace', color: '#ffc400', contrastColor: '#121212' }
    case 1013: case '1013':
      return { label: translatedTextsObject ? translatedTextsObject.confirm : 'Confirm', color: '#ffc400', contrastColor: '#121212' }
    case 1014: case '1014':
      return { label: translatedTextsObject ? translatedTextsObject.spl : 'SPL', color: '#0662BB', contrastColor: '#ffffff' }
    case 1015: case '1015':
      return { label: translatedTextsObject ? translatedTextsObject.acceptedWithWarning : 'Accepted With Warning', color: '#ffc400', contrastColor: '#121212' }
    case 1048: case '1048':
      return { label: translatedTextsObject ? translatedTextsObject.sendSuccessfully : 'Send Successfully', color: '#ffc400', contrastColor: '#121212' }
    case 1049: case '1049':
      return { label: translatedTextsObject ? translatedTextsObject.sendFailed : 'Send Failed', color: '#29A855', contrastColor: '#ffffff' }
    case 'R':
      return { label: translatedTextsObject ? translatedTextsObject.pendingReview : 'Pending Review', color: '#ffc400', contrastColor: '#121212' }
    case 'Y':
      return { label: translatedTextsObject ? translatedTextsObject.reviewInProgress : 'Review In Progress', color: '#0662BB', contrastColor: '#ffffff' }
    case 'G':
      return { label: translatedTextsObject ? translatedTextsObject.reviewed : 'Reviewed', color: '#29A855', contrastColor: '#ffffff' }
    case 'YELLOW':
      return { label: translatedTextsObject ? translatedTextsObject.accepted : 'Accepted', color: '#ffc400', contrastColor: '#121212' }
    case 'RED':
      return { label: translatedTextsObject ? translatedTextsObject.accepted : 'Accepted', color: '#DF2901', contrastColor: '#ffffff' }
    default:
      return { label: status, color: '#121212', contrastColor: '#ffffff' }
  }
}

export {
  getStatusMetadata,
  getStatusMetadataMini,
  StatusStyle,
  ACEStatusStyle,
  SubmitAll,
  AttachAll,
  DisableHighwaySubmitButton,
  DettachAll,
  DisableDeleteButtonForHighway,
  SubmitMultiplefromManifest,
  DisableSubmitButton,
  DisableAttachButton,
  DisableDettachButton,
  DisableDeleteButton,
  DisableInvoiceSubmitButton,
  SubmitAndRedirect
};
